module.exports = __webpack_public_path__ + "0048a6bf6c14e24ae448f4352b6e3ce6.pdf";